import React from "react";
import CustomModalLayoutV2 from "../../../auctionFloor/components/CustomModalLayoutV2";
import { Button } from "../../../../../../shadcn/components/ui/button";

interface OfflineKYCInfoModalProps {
  open: boolean;
  onClose: () => void;
}

export default function OfflineKYCInfoModal({
  open,
  onClose,
}: OfflineKYCInfoModalProps) {
  return (
    <CustomModalLayoutV2
      open={open}
      blurBackground={true}
      onClose={onClose}
      childrenClassName="pb-6 px-6 lg:px-8 overflow-y-scroll"
      className="pt-8 lg:pb-[30px] mx-4 w-full md:w-[500px] overflow-y-scroll max-h-[calc(100%-10px)]"
    >
      <div className="flex flex-col justify-between min-h-[400px]">
        <div className="flex flex-col gap-4">
          <div className="font-semibold text-lg text-brand-textBlack text-center">
            Switch to Offline KYC Mode
          </div>
          <div className="text-xs text-brand-textGrey text-center">
            You are about to switch from Online KYC to Offline KYC mode. Please
            read the following steps carefully to understand the offline KYC
            process.
          </div>

          <div className="bg-brand-lightOrange/30 rounded-lg p-4 mt-2">
            <div className="font-semibold text-sm text-brand-textBlack mb-3">
              What is Offline KYC?
            </div>
            <p className="text-xs text-brand-textGrey leading-relaxed">
              Offline KYC is a manual verification process where you upload your
              documents, fill out the bid application form, and submit the
              physical copy to the bank.
            </p>
          </div>

          <div className="mt-2">
            <div className="font-semibold text-sm text-brand-textBlack mb-3">
              Steps to Complete Offline KYC:
            </div>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-orange text-white flex items-center justify-center text-xs font-semibold mt-0.5">
                  1
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-brand-textBlack mb-1">
                    Upload KYC Documents
                  </p>
                  <p className="text-xs text-brand-textGrey leading-relaxed">
                    Upload your PAN card and one valid ID proof (Aadhaar /
                    Passport / Driving License / Voter ID). If your address
                    proof is different from your ID, upload that as well.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-orange text-white flex items-center justify-center text-xs font-semibold mt-0.5">
                  2
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-brand-textBlack mb-1">
                    Fill the Bid Application Form
                  </p>
                  <p className="text-xs text-brand-textGrey leading-relaxed">
                    Complete the bid application form with all required details
                    including EMD (Earnest Money Deposit) and bid amount
                    information.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-orange text-white flex items-center justify-center text-xs font-semibold mt-0.5">
                  3
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-brand-textBlack mb-1">
                    Download and Submit to Bank
                  </p>
                  <p className="text-xs text-brand-textGrey leading-relaxed">
                    Download the completed bid application form, take a
                    printout, and submit it physically to the bank. After
                    submission, obtain the receiver details from the bank.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 rounded-full bg-brand-orange text-white flex items-center justify-center text-xs font-semibold mt-0.5">
                  4
                </div>
                <div className="flex-1">
                  <p className="text-sm font-medium text-brand-textBlack mb-1">
                    Fill Receiver Details and Submit
                  </p>
                  <p className="text-xs text-brand-textGrey leading-relaxed">
                    Enter the receiver details obtained from the bank and submit
                    the form to complete your auction participation process.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mt-4">
            <p className="text-xs text-yellow-800">
              <span className="font-semibold">Note:</span> Once you switch to
              Offline KYC mode, you will need to complete all the steps above.
              The final bid application must be submitted at the bank
              physically.
            </p>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row gap-3 mt-6 pb-6">
          <Button variant="outline" className="flex-1" onClick={onClose}>
            Cancel
          </Button>
        </div>
      </div>
    </CustomModalLayoutV2>
  );
}
